var React = require('react');

function Checkmark (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0}),React.createElement("g",{"data-name":"Group 284","key":1},[React.createElement("circle",{"cx":"34.81","cy":"34.81","r":"31.39","fill":"#7fc1a8","stroke":"#468858","strokeWidth":"4","data-name":"Ellipse 229","key":0}),React.createElement("path",{"id":"check","fill":"none","stroke":"#fff","strokeMiterlimit":"10","strokeWidth":"9.36","d":"M51.2 19.4L28.5 43.1 17 32.1","key":1})])]);
}

Checkmark.defaultProps = {"id":"checkmark-circle","data-name":"Layer 1","viewBox":"0 0 69.62 69.62"};

module.exports = Checkmark;

Checkmark.default = Checkmark;
